/* CookieBanner — first-visit essential-cookies notice. Remembers choice in localStorage.
   Re-openable via window event 'lx-open-cookie-banner' (fired from footer link). */
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Cookie } from 'lucide-react';

const KEY = 'lx_storage_notice_v61';

export default function CookieBanner() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try { if (!localStorage.getItem(KEY)) setOpen(true); } catch { setOpen(true); }
    const reopen = () => setOpen(true);
    window.addEventListener('lx-open-cookie-banner', reopen);
    return () => window.removeEventListener('lx-open-cookie-banner', reopen);
  }, []);

  if (!open || pathname === '/ai-mentor') return null;

  const accept = () => {
    try { localStorage.setItem(KEY, new Date().toISOString()); } catch { /* dismiss for this page session */ }
    setOpen(false);
  };

  return (
    <div className="fixed bottom-0 inset-x-0 z-[95] p-3 sm:p-4" data-testid="cookie-banner">
      <div className="max-w-3xl mx-auto bg-gray-900 text-gray-100 rounded-2xl shadow-2xl px-4 py-3 sm:px-5 flex flex-col sm:flex-row sm:items-center gap-3">
        <p className="text-sm flex items-start gap-2 flex-1">
          <Cookie size={16} className="text-teal-400 shrink-0 mt-0.5" />
          LearnixTa uses only necessary browser storage to remember your preferences and progress. No advertising cookies, no behavioural analytics, no session replay.
        </p>
        <div className="flex items-center gap-3 shrink-0">
          <Link to="/cookies" className="text-sm font-semibold text-teal-300 hover:text-teal-200 underline underline-offset-2" style={{ minHeight: 44, display: 'inline-flex', alignItems: 'center' }} data-testid="cookie-banner-policy-link">
            Cookie Policy
          </Link>
          <button type="button" onClick={accept}
            className="bg-white text-gray-900 font-bold text-sm px-5 rounded-full hover:bg-gray-100 transition-colors"
            style={{ minHeight: 44 }}
            data-testid="cookie-banner-okay">
            Okay
          </button>
        </div>
      </div>
    </div>
  );
}
